
import { usePageTitle } from '../../hooks/usePageTitle';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import HeroSection from './components/HeroSection';
import WhyChooseSection from './components/WhyChooseSection';
import ServicesPreviewSection from './components/ServicesPreviewSection';
import CasesPreviewSection from './components/CasesPreviewSection';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';

export default function Home() {
  usePageTitle('page_title_home');

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Koluno",
    "url": import.meta.env.VITE_SITE_URL || "https://koluno.com",
    "logo": `${import.meta.env.VITE_SITE_URL || "https://koluno.com"}/logo.png`,
    "description": "Koluno提供达人带货、广告投放、数据复盘一站式整合营销解决方案，帮助品牌快速进入全球市场，提升销量和影响力。",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+86-400-000-0000",
      "contactType": "customer service",
      "email": "business@koluno.com"
    },
    "sameAs": [
      "https://weixin.qq.com/koluno",
      "https://t.me/koluno2020"
    ],
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "CN"
    },
    "foundingDate": "2020",
    "numberOfEmployees": "50-100",
    "industry": "Digital Marketing"
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="Koluno - 达人营销一站式解决方案"
        description="Koluno提供达人带货、广告投放、数据复盘一站式整合营销解决方案，帮助品牌快速进入全球市场，提升销量和影响力。"
        keywords="达人营销,网红带货,广告投放,数据分析,品牌推广,全球市场,KOL营销,社交媒体营销"
        ogTitle="Koluno - 达人营销一站式解决方案"
        ogDescription="Koluno提供达人带货、广告投放、数据复盘一站式整合营销解决方案，帮助品牌快速进入全球市场，提升销量和影响力。"
        ogUrl={`${import.meta.env.VITE_SITE_URL || "https://koluno.com"}/`}
        twitterTitle="Koluno - 达人营销一站式解决方案"
        twitterDescription="Koluno提供达人带货、广告投放、数据复盘一站式整合营销解决方案，帮助品牌快速进入全球市场，提升销量和影响力。"
        structuredData={structuredData}
      />
      
      <Header />
      
      <main>
        <HeroSection />
        <WhyChooseSection />
        <div id="services">
          <ServicesPreviewSection />
        </div>
        <div id="cases">
          <CasesPreviewSection />
        </div>
        <ProcessSection />
        <div id="contact">
          <ContactSection />
        </div>
        <CTASection />
      </main>

      <Footer />
    </div>
  );
}
